// Stub para React Native Web
declare const __REACT_WEB_CONFIG__: Record<string, string>

const Config: Record<string, string> = __REACT_WEB_CONFIG__ || {}

export default Config
